/**
 * Which restaurant this browser is talking to.
 *
 * For staff the server can deduce it from the user's membership, but a QR
 * customer is anonymous: the code carries only a table token, and the
 * `by-token` response is what reveals the restaurant. We keep the slug so
 * every later request can name it.
 */

const STORAGE_KEY = 'tenant_bamidi';

let inMemorySlug: string | null = null;

export const getTenantSlug = (): string | null => {
  if (inMemorySlug) return inMemorySlug;
  try {
    inMemorySlug = localStorage.getItem(STORAGE_KEY);
  } catch {
    // Private mode or blocked storage: the in-memory value still serves
    // this page load.
    inMemorySlug = null;
  }
  return inMemorySlug;
};

export const setTenantSlug = (slug: string | null | undefined): void => {
  if (!slug) return;
  inMemorySlug = slug;
  try {
    localStorage.setItem(STORAGE_KEY, slug);
  } catch {
    // ignored
  }
};

export const clearTenantSlug = (): void => {
  inMemorySlug = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignored
  }
};
